/* Atrius theme script. No libraries. Everything degrades to plain links and forms without it. */
(() => {
const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
const A = window.Atrius || { routes: {} };
const R = A.routes;
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const design = !!(window.Shopify && Shopify.designMode);
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

/* ---------- Money (cents in, store format out) ---------- */
function money(cents, trim = true) {
  const n = (cents || 0) / 100, fmt = A.moneyFormat || '${{amount}}';
  const group = (v, d, t, s) => { const [i, f] = v.toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? s + f : ''); };
  let out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
    if (k === 'amount_no_decimals') return group(n, 0, ',', '.');
    if (k === 'amount_with_comma_separator') return group(n, 2, '.', ',');
    if (k === 'amount_no_decimals_with_comma_separator') return group(n, 0, '.', ',');
    if (k === 'amount_with_apostrophe_separator') return group(n, 2, "'", '.');
    return group(n, 2, ',', '.');
  });
  return trim ? out.replace(/[.,]00(?=\D*$)/, '') : out;
}
const from = p => p.min === p.max ? money(p.min) : 'From ' + money(p.min);

/* ---------- Product registry: every <script data-products> on the page ---------- */
const PRODUCTS = new Map();
function register(root = document) {
  $$('script[data-products], script[data-product-json]', root).forEach(s => {
    try { [].concat(JSON.parse(s.textContent)).forEach(p => p && PRODUCTS.set(p.handle, p)); } catch (e) { console.warn('Atrius: bad product data', e); }
  });
}
register();
const isDefault = p => p.options.length === 1 && p.options[0].values.length === 1 && /^default title$/i.test(p.options[0].values[0]);

/* ---------- Toast ---------- */
function toast(t) { const el = $('#toast'); if (!el) return; el.textContent = t; el.classList.add('on'); clearTimeout(toast.t); toast.t = setTimeout(() => el.classList.remove('on'), 2400); }

/* ---------- Sheets (quick view + cart drawer) ---------- */
const root = document.documentElement;
let lastFocus = null;
function openSheet(id) {
  lastFocus = document.activeElement;
  closeSheets(false);
  root.classList.add('open-' + id); $('#' + id).inert = false;
  setTimeout(() => { const c = $('#' + id + ' [data-close]'); c && c.focus(); }, 50);
}
function closeSheets(refocus = true) {
  root.classList.remove('open-pdp', 'open-cart');
  ['pdp', 'cart'].forEach(id => { const el = $('#' + id); if (el) el.inert = true; });
  if (refocus && lastFocus) lastFocus.focus();
}
document.addEventListener('click', e => { if (e.target.closest('[data-close]') || e.target.id === 'scrim') closeSheets(); });
addEventListener('keydown', e => { if (e.key === 'Escape') { closeSheets(); closeSearch(); } });

/* ---------- Option picker (shared by quick view and product page) ---------- */
function chosenVariant(p, pick) { return pick.every(x => x != null) ? p.variants.find(v => v.opts.every((o, k) => o === pick[k])) : null; }
function initialPick(p, pre) {
  return p.options.map((o, k) => pre ? pre.opts[k] : (o.values.length === 1 ? o.values[0] : null));
}
function optionsHTML(p, pick) {
  if (isDefault(p)) return '';
  return p.options.map((o, k) => `
    <div class="opt-group"><p class="opt-label">${esc(o.name)}${pick[k] ? ': <b>' + esc(pick[k]) + '</b>' : ''}</p><div class="opts" role="group" aria-label="${esc(o.name)}">
      ${o.values.map(val => {
        const vs = p.variants.filter(v => v.opts[k] === val && v.opts.every((x, j) => j === k || pick[j] == null || pick[j] === x));
        const exists = vs.length > 0, avail = vs.some(v => v.available);
        return `<button type="button" aria-pressed="${pick[k] === val}" data-k="${k}" data-val="${esc(val)}" ${exists && avail ? '' : 'class="na"'} ${exists ? '' : 'disabled'} aria-label="${esc(val)}${avail ? '' : ' (sold out)'}">${esc(val)}</button>`;
      }).join('')}
    </div></div>`).join('');
}
function applyPick(p, pick, k, val, toggle = true) {
  pick[k] = toggle && pick[k] === val ? null : val;
  // drop picks that no longer combine into a real variant
  p.options.forEach((_, j) => { if (j !== k && pick[j] != null && !p.variants.some(v => v.opts.every((x, m) => pick[m] == null || pick[m] === x))) pick[j] = null; });
}

/* ---------- Cart (Shopify AJAX API) ---------- */
let cart = null;
async function fetchCart() { try { cart = await (await fetch(R.cart, { headers: { Accept: 'application/json' } })).json(); renderCart(); } catch (e) {} }
async function addToCart(id, quantity) {
  const res = await fetch(R.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }] }) });
  const data = await res.json();
  if (!res.ok) { toast(data.description || data.message || 'Could not add that to the cart'); return false; }
  await fetchCart();
  if (A.cartType === 'page') { location.href = R.cartPage; return true; }
  openSheet('cart');
  return true;
}
async function changeLine(line, quantity) {
  const res = await fetch(R.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
  const data = await res.json();
  if (!res.ok) { toast(data.description || data.message || 'Could not update the cart'); return fetchCart(); }
  cart = data; renderCart();
}
function renderCart() {
  if (!cart) return;
  const count = $('#count'); if (count) count.textContent = cart.item_count;
  const list = $('#cartList'), foot = $('#cartFoot'); if (!list) return;
  foot.hidden = !cart.item_count;
  list.innerHTML = cart.items.length ? cart.items.map((it, k) => `<li>
    ${it.image ? `<img src="${esc(it.image)}${it.image.includes('?') ? '&' : '?'}width=160" alt="" width="64" height="64" loading="lazy">` : '<span></span>'}
    <span><a href="${esc(it.url)}"><b>${esc(it.product_title.replace(/^Atrius /, ''))}</b></a>${it.product_has_only_default_variant ? '' : `<small>${esc(it.variant_title)}</small>`}
      <span class="step" role="group" aria-label="Quantity"><button type="button" data-line="${k + 1}" data-q="${it.quantity - 1}" aria-label="Decrease quantity">&minus;</button><output>${it.quantity}</output><button type="button" data-line="${k + 1}" data-q="${it.quantity + 1}" aria-label="Increase quantity">+</button></span></span>
    <span>${money(it.final_line_price, false)}<br><button type="button" class="rm" data-line="${k + 1}" data-q="0">Remove</button></span></li>`).join('') : '<li class="empty">Your cart is empty.</li>';
  $('#sub').textContent = money(cart.total_price, false);
}
$('#cartList') && $('#cartList').addEventListener('click', e => { const b = e.target.closest('[data-line]'); if (b) { b.disabled = true; changeLine(+b.dataset.line, Math.max(0, +b.dataset.q)); } });
const cartBtn = $('#cartBtn');
if (cartBtn && A.cartType !== 'page') cartBtn.addEventListener('click', e => { if (location.pathname === R.cartPage) return; e.preventDefault(); openSheet('cart'); });
fetchCart();
addEventListener('pageshow', e => { if (e.persisted) fetchCart(); });

/* ---------- Quick view sheet ---------- */
let cur = null, pick = [], qty = 1;
function renderSheet() {
  const p = cur;
  $('#optGroups').innerHTML = optionsHTML(p, pick);
  const v = chosenVariant(p, pick);
  const price = v ? v.price : null;
  $('#pPrice').textContent = price != null ? money(price) : from(p);
  const sold = v ? !v.available : !p.available;
  const btn = $('#addBtn');
  btn.disabled = sold;
  btn.textContent = sold ? 'Sold out' : 'Add to cart' + (price != null || p.min === p.max ? ' / ' + money((price ?? p.min) * qty) : '');
  $('#qtyVal').textContent = qty;
  if (v && v.img) setSheetImg(v.img);
}
function setSheetImg(src) {
  const m = $('#gMain'); m.src = src; m.removeAttribute('srcset');
  $$('#gThumbs button').forEach(x => x.setAttribute('aria-current', x.dataset.g === src));
}
function openQuick(handle, vid) {
  const p = PRODUCTS.get(handle); if (!p || !$('#pdp')) return false;
  cur = p; qty = 1;
  const pre = vid ? p.variants.find(v => v.id === vid) : null;
  pick = initialPick(p, pre);
  $('#pdpLink').href = p.url + (pre ? '?variant=' + pre.id : '');
  setSheetImg(p.imgs[0] || '');
  $('#gMain').alt = p.name;
  $('#gThumbs').innerHTML = p.imgs.length > 1 ? p.imgs.map((src, k) => `<button type="button" aria-current="${k === 0}" data-g="${esc(src)}" aria-label="Photo ${k + 1}"><img src="${esc(src)}" alt="" loading="lazy"></button>`).join('') : '';
  $('#pName').textContent = p.name;
  $('#pDesc').textContent = p.body;
  $('#pdpInfo').classList.remove('need');
  renderSheet(); $('#pdpBody').scrollTop = 0; openSheet('pdp');
  return true;
}
if ($('#pdp')) {
  $('#pdp').addEventListener('click', e => {
    const o = e.target.closest('[data-k]');
    if (o && !o.disabled) { applyPick(cur, pick, +o.dataset.k, o.dataset.val); $('#pdpInfo').classList.remove('need'); renderSheet(); return; }
    const g = e.target.closest('[data-g]'); if (g) setSheetImg(g.dataset.g);
  });
  $('#qtyMinus').onclick = () => { qty = Math.max(1, qty - 1); renderSheet(); };
  $('#qtyPlus').onclick = () => { qty = Math.min(99, qty + 1); renderSheet(); };
  $('#addBtn').onclick = async () => {
    const v = chosenVariant(cur, pick);
    if (!v) {
      const info = $('#pdpInfo'); info.classList.remove('need'); void info.offsetWidth; info.classList.add('need');
      const missing = cur.options.find((o, k) => pick[k] == null);
      toast('Choose a ' + (missing ? missing.name : 'option').toLowerCase() + ' first'); return;
    }
    if (!v.available) { toast('That option is sold out'); return; }
    const btn = $('#addBtn'); btn.disabled = true;
    await addToCart(v.id, qty);
    btn.disabled = false;
  };
}
// Tiles and size-finder results open the quick view; ctrl/cmd-click still opens the product page
document.addEventListener('click', e => {
  const c = e.target.closest('a.p[data-handle], .fit[data-handle]');
  if (!c || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
  if (openQuick(c.dataset.handle, c.dataset.vid ? +c.dataset.vid : null)) e.preventDefault();
});

/* ---------- Catalogue: filter + search + sort ---------- */
$$('[data-catalogue]').forEach(sec => {
  const grid = $('.grid', sec), q = $('[data-shop-q]', sec), sort = $('[data-shop-sort]', sec), none = $('[data-no-hits]', sec);
  let f = 'all';
  function apply() {
    const term = q.value.trim().toLowerCase(), words = term.split(/\s+/).filter(Boolean);
    let shown = 0;
    const cards = $$('.p', grid);
    cards.forEach(c => {
      const ok = (f === 'all' || c.dataset.f.split(' ').includes(f)) && words.every(w => c.dataset.name.includes(w));
      c.hidden = !ok; if (ok) shown++;
    });
    const s = sort.value;
    grid.classList.toggle('filtered', f !== 'all' || !!term || s !== 'featured');
    cards.sort((a, b) => s === 'low' ? a.dataset.min - b.dataset.min : s === 'high' ? b.dataset.max - a.dataset.max : s === 'new' ? b.dataset.created - a.dataset.created : a.dataset.i - b.dataset.i)
      .forEach(c => grid.appendChild(c));
    none.hidden = shown > 0;
  }
  const filters = $('.filters', sec);
  filters && filters.addEventListener('click', e => {
    const b = e.target.closest('[data-filter]'); if (!b) return;
    $$('[data-filter]', filters).forEach(x => x.setAttribute('aria-pressed', x === b));
    f = b.dataset.filter; apply();
  });
  q.addEventListener('input', apply); sort.addEventListener('change', apply);
});

/* ---------- Size finder: every variant whose option names this diameter ---------- */
const round = n => Math.round(n * 100) / 100;
function sizesIn(str) {
  const nums = [], ranges = [];
  const r = /(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)\s*(?:inch(?:es)?|in\b|"|″)/gi;
  let m; while ((m = r.exec(str))) ranges.push([+m[1], +m[2]]);
  const single = /(\d+(?:\.\d+)?)\s*(?:inch(?:es)?|in\b|"|″)/gi;
  while ((m = single.exec(str))) nums.push(round(+m[1]));
  ranges.forEach(([a, b]) => nums.push(round(a), round(b)));
  return { nums, ranges };
}
$$('[data-finder]').forEach(sec => {
  register(sec);
  const list = JSON.parse($('script[data-products]', sec).textContent || '[]');
  const parts = list.map(p => ({ p, vs: p.variants.map(v => ({ v, s: v.opts.map(sizesIn) })) }));
  const all = [...new Set(parts.flatMap(x => x.vs.flatMap(y => y.s.flatMap(z => z.nums))))].sort((a, b) => a - b);
  const sizesEl = $('[data-finder-sizes]', sec), lcd = $('[data-finder-lcd]', sec), fits = $('[data-finder-fits]', sec);
  if (!all.length) { sec.hidden = true; return; }
  const fitsSize = (sz, s) => sz.some(z => z.nums.includes(s) || z.ranges.some(([a, b]) => s >= a && s <= b));
  const first = all.includes(+sec.dataset.default) ? +sec.dataset.default : all[0];
  sizesEl.innerHTML = all.map(s => `<button type="button" aria-pressed="${s === first}" data-s="${s}">${s.toFixed(2).replace(/0$/, '')}&Prime;</button>`).join('');
  function show(s) {
    const hits = parts.map(({ p, vs }) => {
      const ok = vs.filter(x => fitsSize(x.s, s)).map(x => x.v);
      if (!ok.length) return null;
      return { p, v: ok.find(v => v.available) || ok[0] };
    }).filter(Boolean);
    lcd.innerHTML = `OD ${s.toFixed(2)}&Prime;<small>${hits.length} PART${hits.length === 1 ? '' : 'S'} FIT</small>`;
    fits.innerHTML = hits.map(h => `<a class="fit" href="${esc(h.p.url)}?variant=${h.v.id}" data-handle="${esc(h.p.handle)}" data-vid="${h.v.id}"><img src="${esc(h.v.img || h.p.imgs[0] || '')}" alt="" loading="lazy" width="76" height="76"><span><b>${esc(h.p.name)}</b><span>${esc(h.v.opts.join(' / '))} / ${money(h.v.price)}${h.v.available ? '' : ' / sold out'}</span></span></a>`).join('');
  }
  sizesEl.addEventListener('click', e => { const b = e.target.closest('[data-s]'); if (!b) return; $$('button', sizesEl).forEach(x => x.setAttribute('aria-pressed', x === b)); show(+b.dataset.s); });
  show(first);
});

/* ---------- Manual archive search ---------- */
$$('[data-manuals]').forEach(sec => {
  const q = $('[data-manual-q]', sec), none = $('[data-man-none]', sec), allBtn = $('[data-man-all]', sec), limit = +sec.dataset.limit || 0;
  let showAll = !limit;
  function filter() {
    const words = q.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
    let shown = 0, hits = 0;
    $$('.manuals li', sec).forEach(li => { const hit = words.every(w => li.dataset.n.includes(w)); li.hidden = !hit || (!words.length && !showAll && shown >= limit); if (hit) { shown++; hits++; } });
    if (allBtn) allBtn.hidden = !!words.length || showAll || hits <= limit;
    none.hidden = hits > 0;
  }
  allBtn && (allBtn.onclick = () => { showAll = true; filter(); });
  q.addEventListener('input', filter);
  filter();
});

/* ---------- Product page ---------- */
$$('[data-product-page]').forEach(sec => {
  const p = JSON.parse($('[data-product-json]', sec).textContent);
  PRODUCTS.set(p.handle, p);
  const form = $('[data-product-form]', sec), idInput = $('[data-variant-id]', sec), optsEl = $('[data-opts]', sec);
  const priceEl = $('[data-price]', sec), addBtn = $('[data-add]', sec), qtyIn = $('[data-qty-input]', sec), qtyOut = $('[data-qty-val]', sec);
  const mainWrap = $('[data-gal-main]', sec);
  idInput.disabled = false;
  const startId = +new URLSearchParams(location.search).get('variant') || +idInput.value;
  const pk = initialPick(p, p.variants.find(v => v.id === startId));
  let q = 1;
  function setImg(src) {
    const img = $('img', mainWrap); if (!img || !src) return;
    img.src = src; img.removeAttribute('srcset');
    $$('[data-g]', sec).forEach(x => x.setAttribute('aria-current', x.dataset.g === src));
  }
  function render(fromClick) {
    optsEl.innerHTML = optionsHTML(p, pk);
    const v = chosenVariant(p, pk);
    priceEl.textContent = v ? money(v.price) : from(p);
    const sold = v ? !v.available : !p.available;
    addBtn.disabled = sold;
    addBtn.textContent = sold ? 'Sold out' : 'Add to cart';
    if (v) {
      idInput.value = v.id;
      if (fromClick && v.img) setImg(v.img);
      if (fromClick && !isDefault(p)) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
    }
    qtyOut.textContent = q; qtyIn.value = q;
  }
  optsEl.addEventListener('click', e => { const o = e.target.closest('[data-k]'); if (o && !o.disabled) { applyPick(p, pk, +o.dataset.k, o.dataset.val, false); sec.classList.remove('need'); render(true); } });
  $$('[data-qty]', sec).forEach(b => b.onclick = () => { q = Math.min(99, Math.max(1, q + +b.dataset.qty)); render(); });
  $$('[data-g]', sec).forEach(b => b.onclick = () => setImg(b.dataset.g));
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const v = chosenVariant(p, pk);
    if (!v) {
      sec.classList.remove('need'); void sec.offsetWidth; sec.classList.add('need');
      const missing = p.options.find((o, k) => pk[k] == null);
      toast('Choose a ' + (missing ? missing.name : 'option').toLowerCase() + ' first'); return;
    }
    addBtn.disabled = true;
    await addToCart(v.id, q);
    addBtn.disabled = !v.available;
  });
  render();
});

/* ---------- Related products (loaded after the page so it stays fast) ---------- */
$$('[data-related]').forEach(async sec => {
  if (sec.children.length) return;
  try {
    const html = await (await fetch(sec.dataset.url)).text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-related]', doc);
    if (fresh && fresh.children.length) { sec.innerHTML = fresh.innerHTML; register(sec); }
  } catch (e) {}
});

/* ---------- Header: menu + predictive search ---------- */
const nav = $('#nav'), menuBtn = $('#menuBtn');
if (menuBtn) {
  menuBtn.onclick = () => { const o = nav.classList.toggle('open'); menuBtn.setAttribute('aria-expanded', o); };
  nav.addEventListener('click', e => { if (e.target.closest('a')) { nav.classList.remove('open'); menuBtn.setAttribute('aria-expanded', false); } });
}
const ps = $('#psearch'), psQ = $('#psearchQ'), psOut = $('#psearchResults');
function closeSearch() { if (ps && !ps.hidden) ps.hidden = true; }
if (ps && $('#searchBtn')) {
  $('#searchBtn').addEventListener('click', e => { e.preventDefault(); ps.hidden = !ps.hidden; if (!ps.hidden) psQ.focus(); });
  let t, last = '';
  psQ.addEventListener('input', () => {
    clearTimeout(t);
    t = setTimeout(async () => {
      const term = psQ.value.trim(); if (term === last) return; last = term;
      if (term.length < 2) { psOut.innerHTML = ''; return; }
      try {
        const url = `${R.searchSuggest}?q=${encodeURIComponent(term)}&resources[type]=product,collection,page,article&resources[limit]=5&resources[options][unavailable_products]=last`;
        const r = (await (await fetch(url)).json()).resources.results;
        const rows = [
          ...(r.products || []).map(x => `<a href="${esc(x.url)}">${x.image ? `<img src="${esc(x.image)}${x.image.includes('?') ? '&' : '?'}width=120" alt="" width="44" height="44">` : '<span></span>'}<span><b>${esc(x.title.replace(/^Atrius /, ''))}</b><small>${esc(x.price ? money(Math.round(parseFloat(x.price) * 100)) : '')}</small></span></a>`),
          ...(r.collections || []).map(x => `<a href="${esc(x.url)}"><span></span><span><b>${esc(x.title)}</b><small>Collection</small></span></a>`),
          ...(r.pages || []).map(x => `<a href="${esc(x.url)}"><span></span><span><b>${esc(x.title)}</b><small>Page</small></span></a>`),
          ...(r.articles || []).map(x => `<a href="${esc(x.url)}"><span></span><span><b>${esc(x.title)}</b><small>Blog</small></span></a>`)
        ];
        psOut.innerHTML = rows.length ? rows.join('') + `<button class="more" type="submit">See all results for &ldquo;${esc(term)}&rdquo;</button>` : `<p class="note">No matches. Press Enter to search everything.</p>`;
      } catch (e) { psOut.innerHTML = ''; }
    }, 180);
  });
  document.addEventListener('click', e => { if (!ps.hidden && !e.target.closest('#psearch, #searchBtn')) closeSearch(); });
}

/* ---------- 90s layer: boost gauge, tape counter, VHS tracking ---------- */
const needle = $('#needle');
if (needle) {
  const ang = b => -135 + (b + 1) / 3 * 270;
  const pt = (a, r) => { const rad = (a - 90) * Math.PI / 180; return [100 + r * Math.cos(rad), 100 + r * Math.sin(rad)]; };
  let tk = '';
  for (let b = -1; b <= 2.0001; b += 0.25) {
    const major = Math.abs(b * 2 - Math.round(b * 2)) < 1e-6, [x1, y1] = pt(ang(b), major ? 76 : 80), [x2, y2] = pt(ang(b), 88);
    tk += `<line class="tick${major ? '' : ' minor'}" x1="${x1.toFixed(1)}" y1="${y1.toFixed(1)}" x2="${x2.toFixed(1)}" y2="${y2.toFixed(1)}"/>`;
    if (Math.abs(b - Math.round(b)) < 1e-6) { const [tx, ty] = pt(ang(b), 64); tk += `<text x="${tx.toFixed(1)}" y="${(ty + 4).toFixed(1)}">${Math.round(b)}</text>`; }
  }
  $('#ticks').innerHTML = tk;
  const txt = $('#boostTxt');
  let boost = -0.6, target = -0.6;
  const setNeedle = b => { needle.style.transform = `rotate(${ang(b)}deg)`; txt.textContent = (b >= 0 ? '+' : '') + b.toFixed(2); };
  setNeedle(boost);
  if (!reduce) {
    const t0 = performance.now();
    const loop = () => { target += (-0.6 - target) * 0.03; boost += (target - boost) * 0.12; setNeedle(boost); requestAnimationFrame(loop); };
    const sweep = now => { const t = (now - t0) / 1400; boost = t < .5 ? -1 + t * 2 * 3 : 2 - (t - .5) * 2 * 2.6; setNeedle(Math.max(-1, Math.min(2, boost))); if (t < 1) requestAnimationFrame(sweep); else { boost = -0.6; requestAnimationFrame(loop); } };
    requestAnimationFrame(sweep);
    let lastY = scrollY, lastT = performance.now();
    addEventListener('scroll', () => { const now = performance.now(), v = Math.abs(scrollY - lastY) / Math.max(16, now - lastT); lastY = scrollY; lastT = now; target = Math.min(1.85, -0.6 + v * 1.6); }, { passive: true });
  }
}
const tape = $('#tape');
if (tape) {
  const start = Date.now();
  setInterval(() => { const s = Math.floor((Date.now() - start) / 1000) + 12; tape.textContent = `${Math.floor(s / 3600)}:${String(Math.floor(s / 60) % 60).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`; }, 1000);
}
function tracking() { const h = $('.hero-img'); if (h && !reduce) { h.classList.add('tracking'); setTimeout(() => h.classList.remove('tracking'), 800); } }

/* ---------- Ignition intro (homepage, once per visit, never in the theme editor) ---------- */
(function intro() {
  const box = $('#intro');
  if (!box || design) { tracking(); return; }
  let seen = false;
  try { seen = sessionStorage.getItem('atriusStarted') === '1' && !/[?&]intro/.test(location.search); } catch (e) {}
  if (seen) { tracking(); return; }
  const page = [...document.body.children].filter(el => el !== box && el.tagName !== 'SCRIPT');
  page.forEach(el => el.inert = true);
  box.hidden = false; document.body.style.overflow = 'hidden';
  setTimeout(() => $('#keyBtn').focus({ preventScroll: true }), 50);

  // gauges: 240 degree sweep. Tach 0-9 x1000 rpm (redline 7.5), speedo 0-180 km/h (the JDM limiter)
  const P2 = (a, r) => { const t = (a - 90) * Math.PI / 180; return [110 + r * Math.cos(t), 110 + r * Math.sin(t)]; };
  function dial(svg, max, majorStep, minorStep, red, cap) {
    const Ang = v => -120 + v / max * 240;
    let g = `<circle class="bezel" cx="110" cy="110" r="100"/>`;
    if (red != null) { const [x1, y1] = P2(Ang(red), 90), [x2, y2] = P2(Ang(max), 90); g += `<path class="redzone" d="M ${x1.toFixed(1)} ${y1.toFixed(1)} A 90 90 0 0 1 ${x2.toFixed(1)} ${y2.toFixed(1)}"/>`; }
    for (let v = 0; v <= max + 1e-6; v += minorStep) {
      const major = Math.abs(v / majorStep - Math.round(v / majorStep)) < 1e-6, [a, b] = P2(Ang(v), major ? 78 : 84), [c, d] = P2(Ang(v), 93);
      g += `<line class="t${major ? '' : ' s'}${red != null && v >= red ? ' r' : ''}" x1="${a.toFixed(1)}" y1="${b.toFixed(1)}" x2="${c.toFixed(1)}" y2="${d.toFixed(1)}"/>`;
      if (major) { const [tx, ty] = P2(Ang(v), 64); g += `<text x="${tx.toFixed(1)}" y="${(ty + 5).toFixed(1)}">${Math.round(v)}</text>`; }
    }
    g += `<text class="cap" x="110" y="150">${cap}</text><line class="nd" x1="110" y1="110" x2="110" y2="28"/><circle class="hub" cx="110" cy="110" r="9"/>`;
    svg.innerHTML = g;
    const nd = svg.querySelector('.nd');
    return v => nd.style.transform = `rotate(${Ang(Math.max(0, Math.min(max, v)))}deg)`;
  }
  const tach = dial($('#tachSvg'), 9, 1, 0.5, 7.5, '&#215;1000 r/min');
  const speed = dial($('#speedSvg'), 180, 20, 10, null, 'km/h');

  let sound = A.introSound !== false;
  const snd = $('#sndBtn');
  const setSnd = () => { snd.textContent = sound ? 'Sound on' : 'Sound off'; snd.setAttribute('aria-pressed', sound); };
  setSnd(); snd.onclick = () => { sound = !sound; setSnd(); };
  function engine() {
    if (!sound) return;
    let ac;
    try { ac = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { return; }
    const out = ac.createGain(); out.gain.value = 0; out.connect(ac.destination);
    const lp = ac.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 900; lp.connect(out);
    const o1 = ac.createOscillator(); o1.type = 'sawtooth';
    const o2 = ac.createOscillator(); o2.type = 'square';
    const g2 = ac.createGain(); g2.gain.value = .35; o2.connect(g2); g2.connect(lp); o1.connect(lp);
    const lfo = ac.createOscillator(); const lg = ac.createGain(); lg.gain.value = .5; lfo.connect(lg); lg.connect(out.gain);
    const t = ac.currentTime;
    o1.frequency.setValueAtTime(70, t); o2.frequency.setValueAtTime(35, t); lfo.frequency.setValueAtTime(12, t);
    out.gain.setValueAtTime(0, t); out.gain.linearRampToValueAtTime(.18, t + .05);
    o1.frequency.setValueAtTime(120, t + .75); o1.frequency.exponentialRampToValueAtTime(48, t + 1.5);
    o2.frequency.setValueAtTime(60, t + .75); o2.frequency.exponentialRampToValueAtTime(24, t + 1.5);
    lfo.frequency.setValueAtTime(8, t + .75); lg.gain.setValueAtTime(.08, t + .75);
    out.gain.setValueAtTime(.24, t + .75); out.gain.linearRampToValueAtTime(.1, t + 1.6); out.gain.linearRampToValueAtTime(0, t + 2.6);
    [o1, o2, lfo].forEach(o => o.start());
    setTimeout(() => { try { ac.close(); } catch (e) {} }, 2800);
  }

  const keyEl = $('#key'), lights = $$('#lights span'), lcd = $('#introLcd'), dashEl = $('#dash');
  const setPos = n => { keyEl.style.transform = `rotate(${[-40, 0, 35, 75][n]}deg)`; $$('.pos').forEach(p => p.classList.toggle('on', +p.dataset.p === n)); };
  setPos(0);
  const wait = ms => new Promise(r => setTimeout(r, ms));
  const sweep = (fn, a, b, ms) => new Promise(r => { const t0 = performance.now(); const f = now => { const k = Math.min(1, (now - t0) / ms), e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2; fn(a + (b - a) * e); k < 1 ? requestAnimationFrame(f) : r(); }; requestAnimationFrame(f); });
  let started = false, done = false;
  function finish() {
    if (done) return; done = true;
    try { sessionStorage.setItem('atriusStarted', '1'); } catch (e) {}
    box.classList.add('off');
    setTimeout(() => {
      box.hidden = true; document.body.style.overflow = ''; page.forEach(el => el.inert = false);
      tracking();
      const first = $('main .btn'); first && first.focus({ preventScroll: true });
    }, reduce ? 0 : 560);
  }
  async function start() {
    if (started) return; started = true;
    $('.cta-key').textContent = 'Starting'; $('.hint').style.visibility = 'hidden';
    if (reduce) { setPos(3); dashEl.classList.add('lit'); lcd.textContent = 'READY'; await wait(300); return finish(); }
    setPos(1); await wait(260);
    setPos(2); dashEl.classList.add('lit'); lights.forEach(l => l.classList.add('on')); lcd.textContent = 'SYS CHECK';
    await Promise.all([sweep(tach, 0, 9, 520), sweep(speed, 0, 180, 520)]);
    await Promise.all([sweep(tach, 9, 0, 520), sweep(speed, 180, 0, 520)]);
    if (done) return;
    lcd.textContent = 'ATRIUS POWER';
    setPos(3); engine(); dashEl.classList.add('shake');
    const crank = setInterval(() => tach(0.2 + Math.random() * 0.25), 60);
    await wait(750);
    clearInterval(crank); dashEl.classList.remove('shake'); setPos(2);
    lights.forEach(l => l.classList.remove('on'));
    await sweep(tach, 0.3, 1.6, 180); await sweep(tach, 1.6, 0.85, 420);
    lcd.textContent = 'GOLDEN ERA';
    const idle = setInterval(() => tach(0.82 + Math.random() * 0.08), 90);
    await wait(700); clearInterval(idle);
    finish();
  }
  $('#keyBtn').onclick = start;
  $('#skipBtn').onclick = () => { started = true; finish(); };
  box.addEventListener('keydown', e => { if (e.key === 'Escape') { started = true; finish(); } });
})();

/* Theme editor: re-run nothing heavy, just keep sheets closed when a section reloads */
document.addEventListener('shopify:section:load', () => { register(); });
})();
